export default "__VITE_ASSET__B_77gSK4__"